import React, { useEffect, useState } from 'react'
import { midas } from '@resurs/midas'
import PropTypes from 'prop-types'
import { TrixEditor } from 'react-trix'
import './styles.module.scss'

export const TextEditor = ({
  onEditorReady: propsOnEditorReady,
  onChange,
  autoFocus,
  fieldName,
  defaultValue,
  fieldCaption,
}) => {
  const [key, setKey] = useState(Math.random())
  useEffect(() => setKey(Math.random()), [defaultValue])
  const handleEditorReady = editor => {
    if (propsOnEditorReady) {
      propsOnEditorReady(editor)
    }
  }

  useEffect(() => {
    const EventType = 'trix-file-accept'
    const handleEvent = e => {
      e.preventDefault()
    }
    document.addEventListener(EventType, handleEvent)
    return () => {
      document.removeEventListener(EventType, handleEvent)
    }
  }, [])

  return (
    <div className={midas.formGroup}>
      <label className={midas.formLabel} htmlFor={fieldName}>
        {fieldCaption}
      </label>
      <TrixEditor
        key={key}
        mergeTags={[]}
        onChange={onChange}
        onEditorReady={handleEditorReady}
        autoFocus={autoFocus}
        value={defaultValue}
      />
    </div>
  )
}

TextEditor.defaultProps = {
  autoFocus: false,
  defaultValue: '',
  onEditorReady: null,
  onChange: null,
}

TextEditor.propTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldCaption: PropTypes.string.isRequired,
  autoFocus: PropTypes.bool,
  defaultValue: PropTypes.string,
  onEditorReady: PropTypes.func,
  onChange: PropTypes.func,
}
